export default __webpack_public_path__ + "static/media/41.782d6ab7.png";